export default __webpack_public_path__ + "static/media/funko-logo.a80201ab.png";